import { Form } from "react-bootstrap";
import { useLangContext } from "../../../providers/LangProvider/LangProviderContext";
import { RegistrationAcceptPolicyStyled } from "./styled/RegistrationAcceptPolicyStyled";
import { useDispatch } from 'react-redux';
import { useCallback } from "react";
import { locationSlice } from "@/modules/Location/locationReducer";
import { LOCATION_NAMES } from "@/modules/Location/locationConstants";

function RegistrationAcceptPolicy(props) {
    const { className, error, onChange, isShowAdditionalCheckbox } = props;
    const { getLangPath } = useLangContext();
    const dispatch = useDispatch();

    const onClientAgreementClick = useCallback((e) => {
        e.preventDefault();
        dispatch(locationSlice.actions.openLocationAction({ name: LOCATION_NAMES.CLIENT_AGREEMENT }));
    }, [dispatch]);

    const onPrivacyPolicyClick = useCallback((e) => {
        e.preventDefault();
        dispatch(locationSlice.actions.openLocationAction({ name: LOCATION_NAMES.PRIVACY_POLICY }));
    }, [dispatch]);

    return <RegistrationAcceptPolicyStyled className={className}>
        <Form.Group>
            <Form.Check type={'checkbox'} id={'accept-rules'}>
                <Form.Check.Input name="accept-rules" isInvalid={!!error} onChange={onChange}/>
                <Form.Check.Label>
                    {getLangPath('sign_up.accept_terms')}
                    {' '}
                    <span className={'custom-link'}
                          onClick={onPrivacyPolicyClick}>{getLangPath('sign_up.privacy_policy')}</span>
                    {', '}
                    <span className={'custom-link'}
                          onClick={onClientAgreementClick}>{getLangPath('sign_up.client_agreement')}</span>
                    {' '}
                    {getLangPath('sign_up.confirm_being_adult')}
                </Form.Check.Label>
            </Form.Check>
            {
                isShowAdditionalCheckbox && <>
                    <Form.Check type={'checkbox'} id={'accept-rules-multiacc'} className={'mt-2'}>
                        <Form.Check.Input name="accept-rules-multiacc" isInvalid={!!error} onChange={onChange}/>
                        <Form.Check.Label>{getLangPath('sign_up.accept_rules_multiacc')}</Form.Check.Label>
                    </Form.Check>
                    <Form.Check type={'checkbox'} id={'accept-rules-legal-years'} className={'mt-2'}>
                        <Form.Check.Input name="accept-rules-legal-years" isInvalid={!!error} onChange={onChange}/>
                        <Form.Check.Label>{getLangPath('sign_up.accept_rules_legal_years')}</Form.Check.Label>
                    </Form.Check>
                </>
            }
            {
                !!error && (
                    <Form.Control.Feedback type="invalid" className={'d-block'}>
                        {getLangPath(error)}
                    </Form.Control.Feedback>
                )
            }
        </Form.Group>
    </RegistrationAcceptPolicyStyled>
}

export default RegistrationAcceptPolicy;
